import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

const VideoSection = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto"
        >
          <div className="relative aspect-video rounded-2xl overflow-hidden shadow-2xl bg-muted">
            {!isLoaded ? (
              <button
                onClick={() => setIsLoaded(true)}
                className="absolute inset-0 w-full h-full flex items-center justify-center group cursor-pointer"
                aria-label="Play video"
              >
                {/* Thumbnail placeholder */}
                <img
                  src="https://img.youtube.com/vi/HlyMS_ySIgY/maxresdefault.jpg"
                  alt="Son's Island Video Thumbnail"
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors" />
                <div className="relative z-10 w-20 h-20 rounded-full bg-accent flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform">
                  <Play className="w-8 h-8 text-white ml-1" fill="white" />
                </div>
              </button>
            ) : (
              <>
                <iframe
                  src="https://www.youtube-nocookie.com/embed/HlyMS_ySIgY?rel=0&autoplay=1"
                  title="Son's Island Video"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="absolute inset-0 w-full h-full"
                />
                {/* Overlay to cover watermark */}
                <div className="absolute bottom-[calc(8%+5px)] left-[26%] md:left-[23%] bg-black px-3 py-1 md:px-4 md:py-1.5 rounded pointer-events-none">
                  <span className="text-white text-xs md:text-base font-medium tracking-wide">
                    SonsGetaways.com
                  </span>
                </div>
              </>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default VideoSection;
